import { ERROR_NAMES } from './constants';

/**
 * @deprecated Please not use it as error object. Because errors that generated with this won't monitoring.
 */
export class NetworkError extends Error {
	constructor(
		public name: string,
		public cause?: Error | undefined,
	) {
		super('Network Error!');
	}
}

/**
 * This is the raw network error class that only exposes the Response once we
 * know there is an error for sure. The body itself is not streamed yet if you
 * received this error. Should not be exposed to users to prevent incorrectly
 * marking things as network errors.
 * @deprecated Please not use it as error object. Because it will be controlled by other packages we created.
 * If you try to use it as error, you may break something that we made.
 */
export class HTTPError extends NetworkError {
	response: Response;

	constructor(response: Response) {
		// It is important to note that this can be shown to the user if the
		// default transformer is not used for some reason and the thrown error's
		// message is left as is.
		super(ERROR_NAMES.HTTPError);
		this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
		this.response = response;
	}
}

/**
 * This is the network error after streaming the error body. The error message
 * now represents the backend error and safe to display. The cause field still
 * keeps a reference to the original HTTPError
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export class StreamedHTTPError<D = {}> extends HTTPError {
	constructor(
		public cause: HTTPError,
		public data: D,
		public message: string,
	) {
		super(cause.response);
		this.message = message;
		this.name = ERROR_NAMES.StreamedHTTPError;
	}
}

export const isHTTPError = (candidate: any): candidate is HTTPError =>
	candidate instanceof HTTPError ||
	[ERROR_NAMES.HTTPError, ERROR_NAMES.StreamedHTTPError].includes(candidate.name);

export const isNetworkError = (candidate: any): candidate is NetworkError =>
	candidate instanceof NetworkError ||
	[ERROR_NAMES.NetworkError, ERROR_NAMES.HTTPError, ERROR_NAMES.StreamedHTTPError].includes(
		candidate.name,
	);

export const isStreamedHTTPError = (candidate: any): candidate is StreamedHTTPError =>
	candidate instanceof StreamedHTTPError || candidate?.name === ERROR_NAMES.StreamedHTTPError;
